exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-pager {\n  padding: 0.5em;\n}\n.uu5-bricks-column.uu5-bricks-pager-right {\n  text-align: right;\n}\n.uu5-bricks-column.uu5-bricks-pager-up {\n  text-align: right;\n  padding-right: 13%;\n}\n.uu5-bricks-column.uu5-bricks-pager-down {\n  padding-left: 13%;\n}\n.uu5-bricks-pager .uu5-bricks-link {\n  text-decoration: none;\n  font-size: 170%;\n}\n.uu5-bricks-pager .uu5-bricks-link:hover > .uu5-bricks-pager-text {\n  text-decoration: underline;\n}\n.uu5-bricks-pager-text {\n  display: none;\n}\n.uu5-bricks-pager-glyphicon.uu5-bricks-glyphicon {\n  font-weight: bold;\n  top: -0.085em;\n}\n.uu5-bricks-pager.uu5-common-bg .uu5-bricks-pager-link,\n.uu5-bricks-pager.uu5-common-bg .uu5-bricks-pager-glyphicon {\n  color: inherit;\n}\n@media only screen and (min-width: 768px) {\n  .uu5-bricks-pager-text {\n    display: inline-block;\n  }\n  .uu5-bricks-pager .uu5-bricks-link {\n    font-size: 100%;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/pager.less
// module id = 245
// module chunks = 0